import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export const AppDatePicker: React.FC<{
  startDate?: Date
  handleDateChange: (date: Date | null) => void
  className?: string
  isClearable?: boolean
}> = ({ startDate, handleDateChange, className, isClearable = false }) => {
  return (
    <DatePicker
      className={className}
      selected={startDate}
      onChange={(date: Date | null) => handleDateChange(date)}
      onSelect={() => null}
      placeholderText={'Vyberte datum'}
      isClearable={isClearable}
    />
  )
}
